import { ReactNode } from 'react'
import { Header } from './Header'
import { BottomNav } from './BottomNav'
import { cn } from '@/utils/cn'

interface LayoutProps {
  children: ReactNode
  currentPage?: 'feed' | 'chat' | 'blog' | 'biblioteca' // | 'marketplace'
  className?: string
}

export function Layout({ children, currentPage = 'chat', className }: LayoutProps) {
  return (
    <div className={cn("flex flex-col h-screen bg-brand-bg transition-colors duration-300", className)}>
      {/* BOX 1: Header */}
      <div className="flex-shrink-0">
        <Header currentPage={currentPage} />
      </div>

      {/* BOX 2: Main Content */}
      <main className="flex-1 overflow-y-auto scrollbar-thin">
        {children}
      </main>

      {/* BOX 3: Bottom Navigation - Mobile only */}
      <div className="flex-shrink-0 lg:hidden">
        <BottomNav currentPage={currentPage} />
      </div>
    </div>
  )
}